import { useState, useEffect } from "react"
import {
    Box,
    Tag,
    TagLabel,
    TagLeftIcon,
    Text,
    Table,
    TableContainer,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useColorModeValue,
} from "@chakra-ui/react"

import { DiDatabase } from "react-icons/di"
import { MdCached } from "react-icons/md"
import {FaGlobe} from "react-icons/fa";
import { GridItem } from "@/components"

const ResponseHistory = ({ response, ...rest }) => {
    const [list, setList] = useState([])

    const bgColor = useColorModeValue("white", "gray.800")

    useEffect(() => {
        if (response) {
            setList((list) => [response, ...list])
        }
    }, [response])

    const responses = list.map((res, i) => {
        const lookup = Math.round(parseFloat(res.lookupTime) * 10) / 10
        const rtt = Math.round(parseFloat(res.roundTripTime) * 10) / 10

        return (
            <Tr key={i}>
                <Td>
                    {res.status === 200 || res.status === 201 ? (
                        <Tag size="sm" colorScheme="green">{`${res.status} ${res.statusText}`}</Tag>
                    ) : (
                        <Tag size="sm">{`${res.status} ${res.statusText}`}</Tag>
                    )}
                </Td>
                <Td>
                    <Text as="kbd" fontSize="xs">
                        {res.url}
                    </Text>
                </Td>
                <Td>
                    {
                        res.from === "db-cache" || res.from === "api-cache" ? (
                            <Tag size="sm">
                                <TagLeftIcon boxSize="12px" as={MdCached} />
                                <TagLabel>Cache</TagLabel>
                            </Tag>
                        ) : res.from === "db" ? (
                            <Tag size="sm" colorScheme="orange">
                                <TagLeftIcon boxSize="12px" as={DiDatabase} />
                                <TagLabel>DB</TagLabel>
                            </Tag>
                        ): res.from === "origin" ? (
                            <Tag size="sm" colorScheme="green">
                                <TagLeftIcon boxSize="12px" as={FaGlobe} />
                                <TagLabel>Origin</TagLabel>
                            </Tag>
                        ) : null
                    }
                </Td>
                <Td>
                    <Text as="kbd" fontSize="xs">{`${lookup} ms`}</Text>
                </Td>
                <Td>
                    <Text as="kbd" fontSize="xs">{`${rtt} ms`}</Text>
                </Td>
            </Tr>
        )
    })

    return (
        <GridItem {...rest}>
            <TableContainer>
                <Box overflowY="auto" maxHeight="300px">
                    <Table size="sm">
                        <Thead position="sticky" top={0} bgColor={bgColor}>
                            <Tr>
                                <Th>Status</Th>
                                <Th>URL</Th>
                                <Th>Source</Th>
                                <Th>Data Lookup</Th>
                                <Th>Round-Trip</Th>
                            </Tr>
                        </Thead>
                        <Tbody>{responses}</Tbody>
                    </Table>
                </Box>
            </TableContainer>
        </GridItem>
    )
}

export { ResponseHistory }
